export default (value, decimals = 0) => (`${Math.round((value * 100) * (10 ** decimals)) / (10 ** decimals)}%`);
